import { render, staticRenderFns } from "./UserMessageCenter.vue?vue&type=template&id=4a0f8016&scoped=true&"
import script from "./UserMessageCenter.vue?vue&type=script&lang=js&"
export * from "./UserMessageCenter.vue?vue&type=script&lang=js&"
import style0 from "./UserMessageCenter.vue?vue&type=style&index=0&id=4a0f8016&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0f8016",
  null
  
)

export default component.exports